export const normalizeStoreCityName = (city: string) => {
    return String(city).trim().replaceAll(/\s+/g, ' ');
};

export const cityToUrlSlug = (city: string) => {
    return normalizeStoreCityName(city)
        .normalize()
        .replaceAll(/['\u2019]/g, '')
        .split(' ')
        .join('-')
        .toLowerCase();
};
